import { ICopyable } from '../controls/common/icopyable';
import { EditableRecordInterface } from '../controls/inline-editable-table/models/EditableRecordInterface';
import { IAttributeValue } from './interfaces/attribute-value.interface';

export class AttributeValue implements IAttributeValue, ICopyable<AttributeValue>, EditableRecordInterface {
    public id: number = null;
    public attributeId: number = null;
    public code: string = null;
    public name: string = null;
    public order: number = null;

    get editableId(): string | number {
        return this['id'];
    }

    public createCopy(): AttributeValue {
        const instance = new AttributeValue();
        instance.id = this.id;
        instance.attributeId = this.attributeId;
        instance.code = this.code;
        instance.name = this.name;
        instance.order = this.order;

        return instance;
    }

    public static createFormCopy(attributeValue: AttributeValue): IAttributeValue {
        const instance = new AttributeValue();
        instance.id = attributeValue.id;
        instance.attributeId = attributeValue.attributeId;
        instance.code = attributeValue.code;
        instance.name = attributeValue.name;
        instance.order = attributeValue.order;

        return instance;
    }

    public copyFrom(other: any) {
        this.id = other.id;
        this.attributeId = other.attributeId;
        this.code = other.code;
        this.name = other.name;
        this.order = other.order;
    }

    /**
     * Retourne une instance de AttributeValue à partir d'une instance de IAttributeValue.
     * @param other : Instance de IAttributeValue.
     * @returns : Instance de AttributeValue.
     */
    public static from(other: IAttributeValue) {
        if (!!other) {
            const instance = new AttributeValue();

            instance.id = other.id;
            instance.attributeId = other.attributeId;
            instance.code = other.code;
            instance.name = other.name;
            instance.order = other.order;

            return instance;
        } else {
            return null;
        }
    }

    /**
     * Retourne un tableau d'instances de AttributeValue à partir d'un tableau d'instances de IAttributeValue.
     * @param other : Tableau d'instances de IAttributeValue.
     * @returns : Tableau d'instances de AttributeValue.
     */
    public static fromArray(others: IAttributeValue[]) {
        if (!!others) {
            let steps: AttributeValue[] = [];

            others.forEach((x) => {
                const step = AttributeValue.from(x);
                steps.push(step);
            });

            return steps;
        } else {
            return null;
        }
    }
}
